import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsFindBy } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [categories, setCategories] = useState([]);

  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listCategory() {
    let response = await wsFindBy('logi/category', { base_business_partner_id: 10 });
    if (response.success) setCategories(response.data);
  }

  const [zones, setZones] = useState([]);
  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        CodigoCategoria: null,
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            CodigoCategoria: item.CODIGOCATEGORIA,
            tipo: (item.TIPO.toString()).toUpperCase(),
            zonal: item.ZONA,
            cuota: item.CUOTA,
          };
        }),
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.CodigoCategoria) {
      setDataChanging((prev) => ({
        ...prev,
        CodigoCategoria: bPartnerSelect?.CodigoCategoria || '',
      }));
    }
  }, [bPartnerSelect]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) {listCategory();listZones();};
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  return (
    <>
      <Modal
        title={`Nueva Cuota de Categoria para Softys`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.CodigoCategoria
            ? 'sale/cuota-categoria-softys'
            : 'sale/cuota-categoria-softys/multiple'
        }
        dataForce={
          dataChanging.CodigoCategoria
            ? {
                tipo: dataChanging.tipo,
                zonal: dataChanging.zonal,
                CodigoCategoria: dataChanging.CodigoCategoria,
                cuota: dataChanging.cuota,
              }
            : {
                CodigoCategoria: cuota.valueSearch?.CodigoCategoria,
                customers: bPartnerSelect?.customers,
                force: 'N'
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={categories}
            getOptionLabel={(item) => `${item.description} (Código: ${item.code})`}
            renderInput={(params) => (
              <TextField {...params} label="Categorias" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('CodigoCategoria', item?.code); setDataImport(null);}}
            value={categories.find((category) => category.code === dataChanging.CodigoCategoria) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate="CODIGOCATEGORIA"
            sortDuplicate="CODIGOCATEGORIA"
            downTemplate={{
              fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla de cuota para categoria`,
              fields: ['CODIGOCATEGORIA','TIPO','ZONA','CUOTA']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.CodigoCategoria ? (
          <>
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Tipo</InputLabel>
              <Select
                required
                value={dataChanging.tipo || ''}
                inputProps={{
                  name: 'tipo',
                  onChange: (e) => handleChange('tipo', e.target.value),  
                }}
              >
                <MenuItem value="C">Cobertura</MenuItem>
                <MenuItem value="I">Compra</MenuItem>
                <MenuItem value="O">Venta</MenuItem>
              </Select>
            </FormControl>
            <Autocomplete
              disableClearable
              options={zones}
              getOptionLabel={(item) => `${item.description} (Código: ${item.code})`}
              renderInput={(params) => (
                <TextField {...params} label="Zonas" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('zonal', item?.code); setDataImport(null);}}
              value={zones.find((zone) => zone.code === dataChanging.zonal) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <TextField
              label="Cuota en soles"
              fullWidth
              type="number"
              name="cuota"
              margin="normal"
              value={dataChanging.cuota || ''}
              onChange={(e) => handleChange('cuota', e.target.value)}
              required
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});
